import _styled from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { action, runInAction } from "mobx";
import { observer } from "mobx-react";
import { Component, useEffect } from "react";
import styled from "styled-components";
import Button from "../../Styled/Button";
import Icon, { StyledIcon } from "../../Styled/Icon";
import { scrollBars } from "../../Styled/mixins";
import Text from "../../Styled/Text";
import { PortalChild } from "../StandardUserInterface/Portal";
import { PanelButton } from "./Panel";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const WorkflowPanelPortalId = "workflow-panel-portal";
/** Wraps component in Portal, adds TitleBar, ErrorBoundary and Footer (PanelButton) */
const WorkflowPanel = observer(props => {
  const viewState = props.viewState;
  useEffect(function hideTerriaSidePanelOnMount() {
    runInAction(() => {
      viewState.terria.isWorkflowPanelActive = true;
    });
    return () => {
      runInAction(() => {
        viewState.terria.isWorkflowPanelActive = false;
      });
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  return /*#__PURE__*/_jsx(PortalChild, {
    viewState: viewState,
    portalId: WorkflowPanelPortalId,
    children: /*#__PURE__*/_jsxs(Container, {
      className: viewState.topElement === "WorkflowPanel" ? "top-element" : "",
      onClick: action(() => {
        viewState.topElement = "WorkflowPanel";
      }),
      children: [/*#__PURE__*/_jsxs(TitleBar, {
        children: [/*#__PURE__*/_jsx(TitleIcon, {
          glyph: props.icon
        }), /*#__PURE__*/_jsx(Title, {
          children: props.title
        }), !props.closeButtonText && /*#__PURE__*/_jsx(CloseIconButton, {
          onClick: props.onClose
        }), props.closeButtonText && /*#__PURE__*/_jsx(CloseTextButton, {
          onClick: props.onClose,
          children: props.closeButtonText
        })]
      }), /*#__PURE__*/_jsx(Content, {
        children: /*#__PURE__*/_jsx(ErrorBoundary, {
          viewState: viewState,
          children: props.children
        })
      }), props.footer ? /*#__PURE__*/_jsx(_StyledPanelButton, {
        onClick: props.footer.onClick,
        title: props.footer.buttonText
      }) : null]
    })
  });
});
class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    this.props.viewState.terria.raiseErrorToUser(error);
  }
  render() {
    return this.state.hasError ? /*#__PURE__*/_jsx(Error, {
      children: "An error occurred when running the workflow. Please try re-loading the app if the error persists."
    }) : this.props.children;
  }
}
const Container = styled.div.withConfig({
  displayName: "WorkflowPanel__Container",
  componentId: "sc-1kjbffb-0"
})(["position:relative;display:flex;flex-direction:column;font-family:", "px;width:", "px;height:calc(100vh - 2 * ", "px);max-width:", "px;box-sizing:border-box;padding:0 0 5px;"], p => p.theme.fontPop, p => p.theme.workflowPanelWidth, p => p.theme.workbenchMargin, p => p.theme.workflowPanelWidth);
const TitleBar = styled.div.withConfig({
  displayName: "WorkflowPanel__TitleBar",
  componentId: "sc-1kjbffb-1"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:0.7em;border-bottom:1px solid ", ";"], p => p.theme.darkLighter);
const Title = styled(Text).attrs({
  textLight: true,
  extraExtraLarge: true
}).withConfig({
  displayName: "WorkflowPanel__Title",
  componentId: "sc-1kjbffb-2"
})(["flex-grow:1;padding:0 1em;"]);
const TitleIcon = styled(StyledIcon).attrs({
  styledWidth: "24px",
  styledHeight: "24px",
  light: true
}).withConfig({
  displayName: "WorkflowPanel__TitleIcon",
  componentId: "sc-1kjbffb-3"
})([""]);
const Content = styled.div.withConfig({
  displayName: "WorkflowPanel__Content",
  componentId: "sc-1kjbffb-4"
})(["flex-grow:1;overflow:auto;display:flex;flex-direction:column;min-height:0;", ""], p => scrollBars(p));
const CloseIconButton = styled(Button).attrs({
  renderIcon: () => /*#__PURE__*/_jsx(StyledIcon, {
    light: true,
    styledWidth: "20px",
    styledHeight: "20px",
    glyph: Icon.GLYPHS.closeLight
  })
}).withConfig({
  displayName: "WorkflowPanel__CloseIconButton",
  componentId: "sc-1kjbffb-5"
})(["background:none;border:none;"]);
const CloseTextButton = styled(Button).attrs({
  primary: true
}).withConfig({
  displayName: "WorkflowPanel__CloseTextButton",
  componentId: "sc-1kjbffb-6"
})(["font-size:14px;"]);
const Error = styled.div.withConfig({
  displayName: "WorkflowPanel__Error",
  componentId: "sc-1kjbffb-7"
})(["display:flex;height:100%;align-items:center;justify-content:center;text-align:center;color:", ";font-size:14px;"], p => p.theme.textLight);
export default WorkflowPanel;
var _StyledPanelButton = styled(PanelButton).withConfig({
  displayName: "WorkflowPanel___StyledPanelButton",
  componentId: "sc-1kjbffb-8"
})({
  marginBottom: "15px"
});